import React, { useEffect, useState } from 'react';
import './SideDrawer.css';
import SidebarMenu from '../Sidebar/SidebarMenu';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import Logo from 'src/components/Logo';

const SideDrawer = ({ closeSideBar }) => {
  const TopSection = styled(Box)(
    ({ theme }) => `
              display: flex;
              height: 60px;
              justify-content: center;
              align-items: center;
      `
  );

  const menuItemHandler = (value) => {
    closeSideBar(value)
  };

  return (
    <div className="sideDrawer">
      <TopSection>
        <Logo />
      </TopSection>
      <SidebarMenu menuItemHandler={menuItemHandler} />
    </div>
  );
};

export default SideDrawer;
